import { render, staticRenderFns } from "./ProcessSettings.vue?vue&type=template&id=21abb957&scoped=true&"
import script from "./ProcessSettings.vue?vue&type=script&lang=js&"
export * from "./ProcessSettings.vue?vue&type=script&lang=js&"
import style0 from "./ProcessSettings.vue?vue&type=style&index=0&id=21abb957&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abb957",
  null
  
)

export default component.exports